module.exports = __webpack_public_path__ + "media/Hero_banner_v2.6cfe13ab.webm";